// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as EuTrademarksRouteImport } from './routes/eu-trademarks'
import { Route as EuropeanPatentsRouteImport } from './routes/european-patents'
import { Route as PatentAiRouteImport } from './routes/patent-ai'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as ServicesEpoOfficeActionResponseRouteImport } from './routes/services.epo-office-action-response'
import { Route as ServicesEuropeanPatentAttorneyRouteImport } from './routes/services.european-patent-attorney'
import { Route as ServicesEuropeanPatentCostsForUsCompaniesRouteImport } from './routes/services.european-patent-costs-for-us-companies'
import { Route as ServicesEuropeanTrademarkAttorneyRouteImport } from './routes/services.european-trademark-attorney'
import { Route as ServicesForeignAssociateForUsFirmsRouteImport } from './routes/services.foreign-associate-for-us-firms'
import { Route as ServicesPctEuropeanPhaseEntryRouteImport } from './routes/services.pct-european-phase-entry'
import { Route as ToolsEpoRenewalFeesRouteImport } from './routes/tools.epo-renewal-fees'
import { Route as ToolsEuropeanPatentValidationCostsRouteImport } from './routes/tools.european-patent-validation-costs'
import { Route as ToolsRenewalFeeCalculatorRouteImport } from './routes/tools.renewal-fee-calculator'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const EuTrademarksRoute = EuTrademarksRouteImport.update({
            id: '/eu-trademarks',path: '/eu-trademarks',getParentRoute: () => rootRouteImport
          })
const EuropeanPatentsRoute = EuropeanPatentsRouteImport.update({
            id: '/european-patents',path: '/european-patents',getParentRoute: () => rootRouteImport
          })
const PatentAiRoute = PatentAiRouteImport.update({
            id: '/patent-ai',path: '/patent-ai',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const ServicesEpoOfficeActionResponseRoute = ServicesEpoOfficeActionResponseRouteImport.update({
            id: '/services/epo-office-action-response',path: '/services/epo-office-action-response',getParentRoute: () => rootRouteImport
          })
const ServicesEuropeanPatentAttorneyRoute = ServicesEuropeanPatentAttorneyRouteImport.update({
            id: '/services/european-patent-attorney',path: '/services/european-patent-attorney',getParentRoute: () => rootRouteImport
          })
const ServicesEuropeanPatentCostsForUsCompaniesRoute = ServicesEuropeanPatentCostsForUsCompaniesRouteImport.update({
            id: '/services/european-patent-costs-for-us-companies',path: '/services/european-patent-costs-for-us-companies',getParentRoute: () => rootRouteImport
          })
const ServicesEuropeanTrademarkAttorneyRoute = ServicesEuropeanTrademarkAttorneyRouteImport.update({
            id: '/services/european-trademark-attorney',path: '/services/european-trademark-attorney',getParentRoute: () => rootRouteImport
          })
const ServicesForeignAssociateForUsFirmsRoute = ServicesForeignAssociateForUsFirmsRouteImport.update({
            id: '/services/foreign-associate-for-us-firms',path: '/services/foreign-associate-for-us-firms',getParentRoute: () => rootRouteImport
          })
const ServicesPctEuropeanPhaseEntryRoute = ServicesPctEuropeanPhaseEntryRouteImport.update({
            id: '/services/pct-european-phase-entry',path: '/services/pct-european-phase-entry',getParentRoute: () => rootRouteImport
          })
const ToolsEpoRenewalFeesRoute = ToolsEpoRenewalFeesRouteImport.update({
            id: '/tools/epo-renewal-fees',path: '/tools/epo-renewal-fees',getParentRoute: () => rootRouteImport
          })
const ToolsEuropeanPatentValidationCostsRoute = ToolsEuropeanPatentValidationCostsRouteImport.update({
            id: '/tools/european-patent-validation-costs',path: '/tools/european-patent-validation-costs',getParentRoute: () => rootRouteImport
          })
const ToolsRenewalFeeCalculatorRoute = ToolsRenewalFeeCalculatorRouteImport.update({
            id: '/tools/renewal-fee-calculator',path: '/tools/renewal-fee-calculator',getParentRoute: () => rootRouteImport
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogRoute: BlogRouteWithChildren,EuTrademarksRoute: EuTrademarksRoute,EuropeanPatentsRoute: EuropeanPatentsRoute,PatentAiRoute: PatentAiRoute,TermsRoute: TermsRoute,ServicesEpoOfficeActionResponseRoute: ServicesEpoOfficeActionResponseRoute,ServicesEuropeanPatentAttorneyRoute: ServicesEuropeanPatentAttorneyRoute,ServicesEuropeanPatentCostsForUsCompaniesRoute: ServicesEuropeanPatentCostsForUsCompaniesRoute,ServicesEuropeanTrademarkAttorneyRoute: ServicesEuropeanTrademarkAttorneyRoute,ServicesForeignAssociateForUsFirmsRoute: ServicesForeignAssociateForUsFirmsRoute,ServicesPctEuropeanPhaseEntryRoute: ServicesPctEuropeanPhaseEntryRoute,ToolsEpoRenewalFeesRoute: ToolsEpoRenewalFeesRoute,ToolsEuropeanPatentValidationCostsRoute: ToolsEuropeanPatentValidationCostsRoute,ToolsRenewalFeeCalculatorRoute: ToolsRenewalFeeCalculatorRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)